import styled from 'styled-components';

import { color } from '@creditornot/alchemy-react/tokens';

export const VerticalSeparator = styled.div.attrs({ role: 'separator' })`
  align-self: stretch;
  background: ${color.border};
  border-radius: 1px;
  flex-shrink: 0;
  min-height: 100%;
  width: 2px;
`;
